import { ISettings } from '@/modules/settings/shared/types';
import { AssetItemProps } from '@/shared/components/molecules/ChooseAsset/ChooseAsset';

export const priceUnitPerLocales = {
  ar: 'جم',
  en: 'EGP',
};

export const demoAsset: AssetItemProps = {
  id: -1,
  name: 'Demo Farm',
  address: 'Demo Farm Address',
  addressAr: 'Arabic Demo Farm Address',
  entityTypeId: 2,
  companyTypeId: 2,
  country: 'ES',
  city: '',
  currency: 'EUR',
  state: '',
  areaUnit: 'acre',
  measurementSystem: 'METRIC',
  IsInventoryActive: 1,
  inventoryApproval: 1,
  settlementLevel: 1,
};

export const demoModeExcludedAPIs = {
  partial: [
    '/company/portalInsights/company-user',
    '/company/portalInsights/user-profile',
    '/company/portalInsights/home-page/sidebar-checks',
    '/company/portalInsights/logout',
    '/company/portalInsights/check-identifier',
    '/company/sendEyeOtp',
    '/company/portalInsights/login',
    '/company/portalInsights/forget-password',
    '/company/portalInsights/reset-password',
    '/company/portalInsights/signup/request',
    '/company/portalInsights/company-job-titles',
    '/company/portalInsights/signup',
  ],
  exact: [
    '/company/entity',
    '/countries',
    // subscription
    '/company/portalInsights/user-email',
    '/company/portalInsights/send-email-verification',
    '/company/portalInsights/verify-email',
    '/company/portalInsights/subscriptions/subscribe-finalize',
    '/company/portalInsights/subscriptions/subscribe',
    '/company/portalInsights/billing/subscription-plan',
    '/company/portalInsights/billing/upcoming-invoice',
    '/company/portalInsights/subscriptions/plans',
  ],
  pattern: [/^\/company\/portalInsights\/settings\/company\/\d+$/],
};

export const EMBTY_PLACE_HOLDER = '-';

export const companyProperties = ['Farm', 'Packhouse'] as const;

//  TODO: IMP: this should be returned from the backend

export const farmFields = ['plot', 'pivot', 'greenhouse', 'nursery'] as const;

export const farmFieldsDescriptions: Record<ISettings.FarmFieldType, string> = {
  [farmFields[0]]: 'plot-description',
  [farmFields[1]]: 'pivot-description',
  [farmFields[2]]: 'greenhouse-description',
  [farmFields[3]]: 'nursery-description',
};

export const packhouseLines = ['packing-line'] as const;

export const allPropertyFields = [...farmFields, ...packhouseLines] as const;

export const propertyStatus = ['ACTIVE', 'INACTIVE'] as const;

export const areaUnits = ['acre', 'hectare'] as const;

export const measurementSystem = ['IMPERIAL', 'METRIC'] as const;

export const measurementUnits = ['WEIGHT', 'VOLUME', 'SEEDS'] as const;

export const cookieExpires = 1727202181651 / (1000 * 60 * 60 * 24);
